import { Link } from "react-router-dom";
import { FOOTER } from "@/constants/testIds";

const WANDER_LINKS = [
  { to: "/destinations", label: "Destinations" },
  { to: "/about", label: "The Atelier" },
  { to: "/journal", label: "Journal" },
  { to: "/contact", label: "Plan a Journey", testId: FOOTER.inquiry },
];

export default function FooterLinks() {
  return (
    <div className="md:col-span-3">
      <div className="text-[10px] tracking-widest3 uppercase text-ivory/50 mb-6">
        Wander
      </div>
      <ul className="space-y-4 font-light">
        {WANDER_LINKS.map((l) => (
          <li key={l.to}>
            <Link
              to={l.to}
              data-testid={l.testId}
              className="hover:text-goldleaf transition-colors"
            >
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
